import React from 'react'

import { useModelState } from '../../model-hooks/use-model-state'
import ChartLayout from '../../models/chart_layout'
import { useDrawingAutoSaveControls } from '../autosave/use-drawing-auto-save-controls'

interface Props {
  chartLayoutModel: ChartLayout
  ideaNoteRef?: React.RefObject<HTMLTextAreaElement>
}

export function ChartLayoutAutoSaveNote({ chartLayoutModel: chartLayoutModelUnwatched, ideaNoteRef }: Props) {
  const chartLayoutModel = useModelState(chartLayoutModelUnwatched, {
    watchProperties: ['idea'],
  })!
  const { handleIdeaNoteChange } = useDrawingAutoSaveControls(chartLayoutModel)

  const hasIdeaNote = chartLayoutModel.idea?.note !== undefined

  if (!hasIdeaNote) {
    return null
  }

  return (
    <div className="mb-4 text-left text-xs">
      <div>Note:</div>
      <textarea
        ref={ideaNoteRef}
        className="block h-14 border border-gray-300 px-1 py-0.5"
        data-testid="idea-note-textarea"
        style={{ width: chartLayoutModel.width }}
        value={chartLayoutModel.idea?.note ?? ''}
        onChange={(e) => {
          handleIdeaNoteChange(e.target.value)
        }}
      />
    </div>
  )
}
